const tabs = {
  CycleSelection: () => import('@/views/career/CycleSelection'),
  ExecutionTabs: () => import('@/views/career/cycle/CycleExecutionTabs')
}
const state = {
  currentTab: tabs.CycleSelection,
  tabs
}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentTab = state.tabs[tab]
  }
}

const actions = {
  setCareerExecutionTabs({ commit }, tab) {
    commit('SET_TABS', tab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
